module.exports = __webpack_public_path__ + "static/media/benefit_placeholder_2.7fb92067.png";